module.exports = __webpack_public_path__ + "static/media/silestone-white.46870d68.svg";